export const TravelCardRels = {
    GetExternalLink: 'travelCardExternalUrl'
};
